import { useQuery } from "@tanstack/react-query";
import { createServiceTemplate } from "../../api/real-cookie-banner.js";
import { useStores } from "../../store/root.js";
import { QueryKeys } from "../../util/query-keys.js";
/**
 * Create given serviceTemplate via RCB Service API.
 */ function useServiceTemplateCreate(serviceTemplate) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.createServiceTemplate(serviceTemplate), ({ signal })=>{
        return createServiceTemplate({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            body: {
                serviceTemplate
            }
        });
    }, {
        staleTime: Infinity,
        enabled: !!serviceTemplate
    });
}
export { useServiceTemplateCreate };
